import React, { useState } from "react";
import { TextField, Button, Tooltip, Box, Typography } from "@mui/material";
import dayjs from "dayjs";

const StepPersonalInfo = ({ data, onNext, onBack }) => {
  const [form, setForm] = useState({
    first_name: data.first_name || "",
    last_name: data.last_name || "",
    dob: data.dob || "",
    national_id: data.national_id || "",
    passport_number: data.passport_number || "",
  });

  const [errors, setErrors] = useState({});
  const [tooltip, setTooltip] = useState("");

  const validate = () => {
    let newErrors = {};

    if (!form.first_name) newErrors.first_name = "First name required";
    if (!form.last_name) newErrors.last_name = "Last name required";

    if (!form.dob) {
      newErrors.dob = "Date of birth required";
    } else {
      const age = dayjs().diff(dayjs(form.dob), "year");
      if (age < 18) {
        newErrors.dob = "Must be 18+";
        setTooltip("❌ Age must be 18 or older");
      } else {
        setTooltip("✔ Valid age");
      }
    }

    // At least one ID must be filled
    if (!form.national_id && !form.passport_number) {
      newErrors.national_id = "Provide National ID or Passport Number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    if (validate()) {
      onNext(form);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6" align="center">
        Personal Information
      </Typography>

      <TextField
        name="first_name"
        label="First Name"
        value={form.first_name}
        onChange={handleChange}
        error={!!errors.first_name}
        helperText={errors.first_name}
        fullWidth
      />

      <TextField
        name="last_name"
        label="Last Name"
        value={form.last_name}
        onChange={handleChange}
        error={!!errors.last_name}
        helperText={errors.last_name}
        fullWidth
      />

      <Tooltip
        title={tooltip}
        placement="right"
        open={Boolean(tooltip)}
        disableHoverListener
      >
        <TextField
          name="dob"
          type="date"
          label="Date of Birth"
          value={form.dob}
          onChange={handleChange}
          error={!!errors.dob}
          helperText={errors.dob}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
      </Tooltip>

      <TextField
        name="national_id"
        label="National ID"
        value={form.national_id}
        onChange={handleChange}
        error={!!errors.national_id}
        helperText={errors.national_id}
        fullWidth
      />

      <TextField
        name="passport_number"
        label="Passport Number (optional)"
        value={form.passport_number}
        onChange={handleChange}
        fullWidth
      />

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button
          onClick={onBack}
          variant="outlined"
          sx={{
            borderRadius: "2rem",
            px: 4,
            borderColor: "#00f0ff",
            color: "#00f0ff",
            "&:hover": { borderColor: "#ff00f0", color: "#ff00f0" },
          }}
        >
          Back
        </Button>

        <Button
          onClick={handleNext}
          variant="contained"
          sx={{
            borderRadius: "2rem",
            px: 4,
            background: "linear-gradient(90deg, #00f0ff, #ff00f0)",
            color: "#fff",
            "&:hover": { background: "linear-gradient(90deg, #ff00f0, #00f0ff)" },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default StepPersonalInfo;
